import { render, staticRenderFns } from "./PrivacyEN.vue?vue&type=template&id=b4a8e23e&"
import script from "./PrivacyEN.vue?vue&type=script&lang=js&"
export * from "./PrivacyEN.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports